/**
 * @description HeatmapNotification module.
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module services/classes/HeatmapNotification
 */

/**
 * @description A class that handles an individual notification.
 * @class
 */
class HeatmapNotification {

    /**
     * Creates an instance of Notification.
     * @param {string | number} id - a unique Id for the notification.
     * @param {Object} notification - an object containing the notification information.
     */
    constructor(id, notification) {
        this.id = id;
        this.type = notification.type || 'info';
        this.title = notification.title;
        this.message = notification.message;
        this.actionButtonText = notification.actionButtonText || 'OK';
        this.action = notification.action;
        this.onClose = notification.onClose;
        this.timestamp = new Date();
    }

    /**
     * @description Returns the notification details.
     * @returns The notification details.
     */
    getNotification() {
        return {
            id: this.id,
            type: this.type,
            title: this.title,
            message: this.message,
            hasAction: !!this.action,
            actionButtonText: this.actionButtonText
        };
    }

    /**
     * @description triggers the action.
     */
    handleAction() {
        this.action && this.action();
    }

    /**
     * @description Triggers the close action.
     */
    handleClose() {
        this.onClose && this.onClose();
    }
}

export default HeatmapNotification;